
  import { Component } from 'vue-property-decorator'
  import Cell from './cell'
  import { EnablementTask } from '@/entities/purchase'
  import SupervisorEnablementTaskForm from '@/views/forms/custom/SupervisorEnablementTaskForm.vue'

@Component({
  components: {
    SupervisorEnablementTaskForm,
  },
})
  export default class EnablementTaskDetailCell extends Cell {
    declare item: EnablementTask
    showDialog: boolean = false

    buttonHandler () {
      this.showDialog = true
    }

    get disableButton () {
      return Boolean(!this.item?.closingReason?.id)
    }
  }
